jQuery(document).ready(function ($) {

  if (typeof wp !== 'undefined' && wp.domReady) {
    wp.domReady(function () {
      setTimeout(function () {
        initializeSplideHero();
      }, 500); // Delay after the DOM is ready
    });
  } else {
    initializeSplideHero();
  }

  function initializeSplideHero() {
    const splideElements = document.querySelectorAll('.home-section-gallery__slider .splide');

    if (splideElements.length) {
      splideElements.forEach((element) => {
        const splide = new Splide(element, {
          type: 'loop',
          perPage: 3,
          focus: 'center',
          arrows: false,
          autoplay: true,
          interval: 8000,
          flickMaxPages: 3,
          updateOnMove: true,
          pagination: false,
          padding: '12%',
          throttle: 300,
          breakpoints: {
            1440: {
              perPage: 1,
              padding: '30%',
            },
            767: {
              perPage: 1,
              padding: '15%',
            },
          },
        });

        // Initialize the slider
        splide.mount();

        // Force reposition after mount
        splide.on('mounted', function () {
          setTimeout(() => {
            splide.go(0);
          }, 100);
        });
      });
    }

    // Initialize GLightbox
    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    });
  }
});
